import { addMilliseconds, addSeconds, eachDayOfInterval, eachHourOfInterval, endOfDay, endOfHour, format, startOfDay, startOfHour } from 'date-fns'
import { Box, Tooltip, Typography } from '@mui/material';

export class CalendarViewFunctions {

    getDayInterval = (startDate, endDate, dayFormat) => {
        let dayInterval = eachDayOfInterval({ start: startDate, end: endDate });
        // const formattedDays = dayInterval.map(date => format(date, dayFormat));
        return dayInterval
    }

    getDayIntervalWithFormat = (rateStartDate, rateEndDate, dayFormat, calendarStartDate, calendarEndDate) => {
        let dayInterval = eachDayOfInterval({ start: rateStartDate, end: rateEndDate });
        const formattedDays = dayInterval.filter((date) => new Date(date) >= new Date(calendarStartDate) && new Date(date) <= new Date(calendarEndDate)).map(date => format(date, dayFormat));
        return formattedDays
    }

    getHourInterval = (startDate, endDate, dayFormat) => {
        let hourInterval = eachHourOfInterval({ start: startOfDay(startDate), end: endOfDay(startDate) });
        // const formattedDays = dayInterval.map(date => format(date, dayFormat));
        return hourInterval
    }

    getHourIntervalWithFormat = (startDate, dayFormat, rate) => {
        let startTimeDate = addSeconds(startOfDay(startDate), rate?.timeFrom)
        let endTimeDate = addSeconds(startOfDay(startDate), rate?.timeTo)
        let dayInterval = eachHourOfInterval({ start: startOfHour(startTimeDate), end: endOfHour(endTimeDate) });
        const formattedDays = dayInterval.map(date => format(date, dayFormat));
        return formattedDays
    }

    getTableHeader = async (startDate, endDate) => {
        // const startOfYear = new Date(year, month, 1);
        // const endOfYear = new Date(year, month + 1, 0);
        // const allDaysOfYear = getDayInterval(startOfYear, endOfYear);

        const formattedDaysOfYear = this.getDayInterval(startDate, endDate, "EEE dd MMM yyyy");

        let startColumn = {
            accessorKey: "categories", header: 'Car Type', Header: ({ column }) => {
                return (
                    <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                        <Typography sx={{ fontSize: "20px", fontWeight: "bold" }}>{column.columnDef.header}</Typography>
                    </Box>
                )
            },
        }
        let tableHeader = formattedDaysOfYear.map((day, index) => ({
            accessorKey: format(day, "EEE dd MMM yyyy"), header: format(day, "EEE dd MMM yyyy"), Header: ({ column }) => {
                // console.log("column", column)
                return (
                    <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                        <Typography sx={{ lineHeight: "15px" }}>{format(day, "EEE")}</Typography>
                        <Typography sx={{ lineHeight: "20px", fontWeight: "bold" }}>{format(day, "dd")}</Typography>
                        <Typography sx={{ lineHeight: "15px" }}>{format(day, "MMM")}</Typography>
                    </Box>
                )
            },
        }))
        tableHeader.splice(0, 0, startColumn);
        return tableHeader
    }

    getTableHeaderAttendance = async (startDate, endDate) => {
        // const startOfYear = new Date(year, month, 1);
        // const endOfYear = new Date(year, month + 1, 0);
        // const allDaysOfYear = getDayInterval(startOfYear, endOfYear);

        const formattedDaysOfYear = this.getDayInterval(startDate, endDate, "EEE dd MMM yyyy");

        let startColumn = {
            accessorKey: "categories", header: 'ID', Header: ({ column }) => {
                return (
                    <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                        <Typography sx={{ fontSize: "20px", fontWeight: "bold" }}>{column.columnDef.header}</Typography>
                    </Box>
                )
            },
        }
        let tableHeader = formattedDaysOfYear.map((day, index) => ({
            accessorKey: format(day, "EEE dd MMM yyyy"), header: format(day, "EEE dd MMM yyyy"), Header: ({ column }) => {
                // console.log("column", column)
                return (
                    <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                        <Typography sx={{ lineHeight: "15px" }}>{format(day, "EEE")}</Typography>
                        <Typography sx={{ lineHeight: "20px", fontWeight: "bold" }}>{format(day, "dd")}</Typography>
                        <Typography sx={{ lineHeight: "15px" }}>{format(day, "MMM")}</Typography>
                    </Box>
                )
            },
        }))
        // tableHeader.splice(0, 0, startColumn);
        return tableHeader
    }
    getTableHeaderWithHours = async (startDate, endDate) => {
        // const startOfYear = new Date(year, month, 1);
        // const endOfYear = new Date(year, month + 1, 0);
        // const allDaysOfYear = getDayInterval(startOfYear, endOfYear);

        const formattedDaysOfYear = this.getHourInterval(startDate, endDate, "EEE dd MMM yyyy HH");

        let startColumn = {
            accessorKey: "categories", header: 'Car Type', Header: ({ column }) => {
                return (
                    <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                        <Typography sx={{ fontSize: "20px", fontWeight: "bold" }}>{column.columnDef.header}</Typography>
                    </Box>
                )
            },
        }
        let tableHeader = formattedDaysOfYear.map((day, index) => ({
            accessorKey: format(day, "EEE dd MMM yyyy HH"), header: format(day, "EEE dd MMM yyyy HH"), Header: ({ column }) => {
                // console.log("column", column)
                return (
                    <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                        <Typography sx={{ lineHeight: "15px" }}>{format(day, "EEE")}</Typography>
                        <Typography sx={{ lineHeight: "20px", fontWeight: "bold" }}>{format(day, "dd")}</Typography>
                        <Typography sx={{ lineHeight: "15px" }}>{format(day, "HH")}:00</Typography>
                    </Box>
                )
            },
        }))
        tableHeader.splice(0, 0, startColumn);
        return tableHeader
    }


    getCalendarData = async (rateData, onEditClick, isHour, startDate, endDate) => {
        try {
            let output = []
            const result = Object.groupBy(rateData, ({ carTypeName }) => carTypeName);
            for (let car_type in result) {
                let rates = {
                    "categories": car_type,
                    "subRows": []
                }
                for (let rate of result[car_type]) {
                    if (rate.bookingSource) {
                        if (isHour) {
                            if (((new Date(startDate) >= new Date(rate.applicableFromDate) && new Date(startDate) <= new Date(rate.applicableToDate))
                                || (new Date(startDate).getDate() === new Date(rate.applicableFromDate).getDate() || new Date(startDate).getDate() === new Date(rate.applicableToDate).getDate()))
                                && rate?.timeFrom < rate?.timeTo) {

                                let colorCode = rate?.isActive ? rate?.isPriority ? { bgColor: "#FFE3DF", color: '#FF2500' } : { bgColor: "rgba(57, 181, 74, 0.7)", color: '#39B54A' } : { bgColor: "#FFF1E5", color: "#FFA500" }
                                const dayIntervals = this.getHourIntervalWithFormat(startDate, 'EEE dd MMM yyyy HH', rate)
                                const divPlacementIndex = (Math.ceil((dayIntervals.length / 2)) - 1)
                                const finalRateData = dayIntervals.reduce((acc, day, index) => {
                                    // const subRowIndex = rates.subRows.findIndex(existingRate => existingRate.categories === rate.bookingSource);
                                    let element = <Tooltip arrow title={<div><div>Rate Id : {rate.id}</div><div>Charge Per Km : {rate.perKmCharge}/Km</div></div>}>
                                        <div data-meta={rate?.id} onClick={() => onEditClick(rate)} style={{ margin: "5px 0px", display: "flex", alignItems: "center", justifyContent: "center", width: "100%", height: '20px', borderBottomLeftRadius: (index === 0) && "4px", borderTopLeftRadius: (index === 0) && "4px", borderTopRightRadius: (index === (dayIntervals.length - 1)) && "4px", borderBottomRightRadius: (index === (dayIntervals.length - 1)) && "4px", color: colorCode?.color, backgroundColor: colorCode?.bgColor }}>{(index === divPlacementIndex) && `${rate?.perKmCharge}/km`}</div>
                                    </Tooltip>
                                    // if (subRowIndex >= 0 && rates.subRows[subRowIndex][day]) {
                                    //     acc[day] = [...rates.subRows[subRowIndex][day], element]
                                    // } else {
                                    //     acc[day] = [element]
                                    // }
                                    acc[day] = element
                                    return acc;
                                }, {})

                                const existingRateIndex = rates.subRows.findIndex(existingRate => existingRate.categories === rate.bookingSource);

                                if (existingRateIndex !== -1) {

                                    rates.subRows[existingRateIndex] = {
                                        ...rates.subRows[existingRateIndex],
                                        subRows: Object.keys(finalRateData).length > 0 ? [
                                            ...rates.subRows[existingRateIndex]["subRows"],
                                            {
                                                categories: rate.id,
                                                ...finalRateData
                                            }
                                        ] : [
                                            ...rates.subRows[existingRateIndex]["subRows"],
                                        ]
                                    };
                                } else {

                                    rates.subRows.push({
                                        "categories": rate.bookingSource,
                                        "subRows": Object.keys(finalRateData).length > 0 ? [
                                            {
                                                categories: rate.id,
                                                ...finalRateData
                                            }
                                        ] : []
                                    });
                                }
                            }
                        } else {
                            if (rate.applicableFromDate && rate.applicableToDate && (new Date(rate.applicableFromDate) < new Date(rate.applicableToDate))) {
                                let colorCode = rate?.isActive ? rate?.isPriority ? { bgColor: "#FFE3DF", color: '#FF2500' } : { bgColor: "rgba(57, 181, 74, 0.7)", color: '#39B54A' } : { bgColor: "#FFF1E5", color: "#FFA500" }
                                const dayIntervals = this.getDayIntervalWithFormat(new Date(rate.applicableFromDate), new Date(rate.applicableToDate), 'EEE dd MMM yyyy', startDate, endDate)
                                const divPlacementIndex = (Math.ceil((dayIntervals.length / 2)) - 1)
                                const finalRateData = dayIntervals.reduce((acc, day, index) => {
                                    // const subRowIndex = rates.subRows.findIndex(existingRate => existingRate.categories === rate.bookingSource);
                                    let element = <Tooltip arrow title={<div><div>Rate Id : {rate.id}</div><div>Charge Per Km : {rate.perKmCharge}/Km</div></div>}>
                                        <div data-meta={rate?.id} onClick={() => onEditClick(rate)} style={{ margin: "5px 0px", display: "flex", alignItems: "center", justifyContent: "center", width: "100%", height: '20px', borderBottomLeftRadius: (index === 0) && "4px", borderTopLeftRadius: (index === 0) && "4px", borderTopRightRadius: (index === (dayIntervals.length - 1)) && "4px", borderBottomRightRadius: (index === (dayIntervals.length - 1)) && "4px", color: colorCode?.color, backgroundColor: colorCode?.bgColor }}>{(index === divPlacementIndex) && `${rate?.perKmCharge}/km`}</div>
                                    </Tooltip>
                                    // if (subRowIndex >= 0 && rates.subRows[subRowIndex][day]) {
                                    //     acc[day] = [...rates.subRows[subRowIndex][day], element]
                                    // } else {
                                    //     acc[day] = [element]
                                    // }
                                    acc[day] = element
                                    return acc;
                                }, {})

                                const existingRateIndex = rates.subRows.findIndex(existingRate => existingRate.categories === rate.bookingSource);

                                if (existingRateIndex !== -1) {

                                    rates.subRows[existingRateIndex] = {
                                        ...rates.subRows[existingRateIndex],
                                        subRows: Object.keys(finalRateData).length > 0 ? [
                                            ...rates.subRows[existingRateIndex]["subRows"],
                                            {
                                                categories: rate.id,
                                                ...finalRateData
                                            }
                                        ] : [
                                            ...rates.subRows[existingRateIndex]["subRows"],
                                        ]
                                    };
                                } else {

                                    rates.subRows.push({
                                        "categories": rate.bookingSource,
                                        "subRows": Object.keys(finalRateData).length > 0 ? [
                                            {
                                                categories: rate.id,
                                                ...finalRateData
                                            }
                                        ] : []
                                    });
                                }
                            }
                        }
                    }

                }
                output.push(rates)
            }
            console.log("output", output)
            return output
        } catch (error) {
            console.error("Error Getting Calendar Data:", error)
        }
    }


    getAttendanceCalendarData = async (leaveData, isHour, startDate, endDate) => {
        try {
            let output = [];
    
            for (let block of leaveData) {
                // if (block.isBlocked) {
                    // Ensure blockedFrom and blockedTo are valid and within date range
                    if (block.blockedFrom && block.blockedTo && (new Date(block.blockedFrom) <= new Date(block.blockedTo))) {
                        // let colorCode = {  bgColor: "rgba(255, 0, 0, 0.7)", color: '#000000' };  // Green color
                        
                        let colorCode;
                        let blockStatus;
                        let reason;
                          
                        if (block.isAvailable === false && block.isActive === false) {
                            colorCode = { bgColor: "rgba(0, 255, 0, 0.7)", color: '#000000' }; // Green color for unblocked
                            blockStatus = "Unblock";
                            reason = block.unblockedReason; // Show unblocked reason
                        } else {
                            colorCode = { bgColor: "rgba(255, 0, 0, 0.7)", color: '#000000' }; // Red color for blocked
                            blockStatus = "Blocked";
                            reason = block.blockedReason; // Show blocked reason
                        }
        
                        const dayIntervals = this.getDayIntervalWithFormat(
                            new Date(block.blockedFrom), 
                            new Date(block.blockedTo), 
                            'EEE dd MMM yyyy', 
                            startDate, 
                            endDate
                        );
                        
                        const divPlacementIndex = Math.floor(dayIntervals.length / 2);
    
                        const finalBlockData = dayIntervals.reduce((acc, day, index) => {
                            acc[day] = (
                                <Tooltip 
                                    arrow 
                                    title={
                                        <div>
                                            <div>Block Id: {block.id}</div>
                                            <div>Driver Id: {block.driverId}</div>
                                            <div>{blockStatus} Reason: {reason}</div>
                                            {/* <div>Reason:{block.blockedReason}</div> */}
                                            <div>From: {block.blockedFrom}</div>
                                            <div>To: {block.blockedTo}</div>
                                        </div>
                                    }
                                >
                                    <div 
                                        data-meta={block.id} 
                                        style={{
                                            margin: "5px 0px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            width: "100%",
                                            height: '20px',
                                            borderBottomLeftRadius: (index === 0) && "4px",
                                            borderTopLeftRadius: (index === 0) && "4px",
                                            borderTopRightRadius: (index === (dayIntervals.length - 1)) && "4px",
                                            borderBottomRightRadius: (index === (dayIntervals.length - 1)) && "4px",
                                            color: colorCode.color,
                                            backgroundColor: colorCode.bgColor
                                        }}
                                    >
                                          {(index === divPlacementIndex) && blockStatus}
                                        {/* {(index === divPlacementIndex) && `Blocked`} */}
                                    </div>
                                </Tooltip>
                            );
                            return acc;
                        }, {});
    
                        output.push({
                            categories: block.id.toString(),
                            ...finalBlockData
                        });
                    }
                // }
            }
    
            console.log("output", output);
            return output;
        } catch (error) {
            console.error("Error Getting Calendar Data:", error);
        }
    }



}